var map = {
	"./black/zanting2.png": "V1Ul",
	"./blue/zanting2.png": "x1Nz",
	"./white/zanting2.png": "29Xb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2NK";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/zanting2\.png$
// module id = g2NK
// module chunks = 24